module.exports = __webpack_public_path__ + "img/255x420.5589378f.png";